import React from 'react';
import HomepageHero from '../components/HomepageHero/HomepageHero';
import VisionSection from '../components/VisionSection/VisionSection';
import SunglassesSection from '../components/SunglassesSection/SunglassesSection';
import CollectionSection from '../components/CollectionSection/CollectionSection';
import ReviewSection from '../components/ReviewSection/ReviewSection';
import BookingSection from '../components/BookingSection/BookingSection';
import Footer from '../components/Footer/Footer';
import { Helmet } from 'react-helmet';
const Home = () => {
  const listordesc = ["",
    "Advanced lens technology from Nikon and Essilor for perfect clarity",
    "",
    "Designer eyewear from Gucci, Ray-Ban, Oakley and more"
  ];
  return (
    <>
    <Helmet>
      <title>
        Elite Optix | Premier Eye Care & Designer Eyewear
      </title>
      <meta 
        name="description"
        content="Experience exceptional eye care and explore our curated collection of luxury eyewear at Elite Optix. Book your comprehensive eye exam today!"
      />
      <link rel="canonical" href="https://eliteoptix.com/" />
    </Helmet>
      <HomepageHero />
      {/* <DividerSection /> */}
      <VisionSection page="home"
        title="Where Vision Meets Style"
        subtext="At Elite Optix, eye care is more than a service, it is a passion. Our expert team provides comprehensive eye exams and personalized vision solutions using the latest lens technology from Nikon and Essilor."
        subtexttwo='Step into our modern boutique to explore a curated collection of designer frames from Gucci, Balenciaga, Ray-Ban, Oakley, Michael Kors, Versace and more. From everyday classics to bold fashion statements, we ensure your eyewear reflects your personality while delivering perfect clarity.'
        listordesc={listordesc}
        buttontext='Discover Our Story'
      />
      <SunglassesSection />
      <div className='bg_gradient'>
        <CollectionSection />
        <ReviewSection />
        <BookingSection />
      </div>
      <Footer />
    </>
  );
};

export default Home;